export const environment = {
  production: true,
  apiUrl: 'https://courierv2.ordinaryexpertsjm.com',
  whatsappUrl: 'https://whatsapp.byllkreate.com',
  apiVersion: 'api',
  version: '2.9.18',
  stripePublishableKey:
    'pk_live_51PP670FfW5NEWSxbNOuBG9PcHQhZduG4vPtCf6rH5meJbiBpM6JKAlQP7UtGoOyZOhPduogsjsys1fD7yhIX0t6u00wZAoJixE'
};
